const _excluded = ["startBillingAt"],
  _excluded2 = ["startBillingAt"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { makeBillUpfrontState } from "../service-billing/makers";
import { isEqual } from 'lodash-es';
import { EffectiveDateSource } from "./model";
import { isBilledUpfront, isPaused, isProrated, isSkipBillingOnAcceptance, startBillingAt as startBillingAtSelector } from "./selectors";
import { makeAwaitingApprovalStatus } from "./makers";
import produce from 'immer';
export let ToggledField = /*#__PURE__*/function (ToggledField) {
  ToggledField["IsBilledUpfront"] = "isBilledUpfront";
  ToggledField["IsPaused"] = "isPaused";
  ToggledField["IsProrated"] = "isProrated";
  ToggledField["BillOnAcceptance"] = "billOnAcceptance";
  ToggledField["StartBillingAt"] = "startBillingAt";
  return ToggledField;
}({});

/** Toggles billing properties for a new (awaiting-approval) ongoing service. */
export function toggleNewOngoingBilling(service, field, additionalOptions) {
  const currentStartBillingAt = startBillingAtSelector(service);
  const relevantBilling = {
    isBilledUpfront: isBilledUpfront(service),
    isPaused: isPaused(service),
    isProrated: isProrated(service),
    billUpfrontState: makeBillUpfrontState(isSkipBillingOnAcceptance(service)),
    startBillingAt: additionalOptions !== null && additionalOptions !== void 0 && additionalOptions.effectiveDate ? false : !!currentStartBillingAt
  };
  const mode = toNewOngoingBillingMode(relevantBilling);
  const newMode = changeNewOngoingBillingMode(mode, field);
  const newState = fromNewOngoingBillingMode(newMode);
  return produce(service, s => {
    var _additionalOptions$ef;
    const {
        startBillingAt
      } = newState,
      billing = _objectWithoutProperties(newState, _excluded);
    s.billing = _objectSpread(_objectSpread({}, s.billing), billing);
    s.status = makeAwaitingApprovalStatus({
      effectiveDate: startBillingAt ? (_additionalOptions$ef = additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.effectiveDate) !== null && _additionalOptions$ef !== void 0 ? _additionalOptions$ef : currentStartBillingAt : null,
      effectiveDateSource: startBillingAt ? EffectiveDateSource.User : null
    });
  });
}
export const getValidOngoingBilling = relevantBilling => {
  const _getValidNewOngoingBi = getValidNewOngoingBilling(relevantBilling),
    {
      startBillingAt: _
    } = _getValidNewOngoingBi,
    billing = _objectWithoutProperties(_getValidNewOngoingBi, _excluded2);
  return billing;
};

/** Returns valid billing properties for a new (awaiting-approval) ongoing service. */
export function getValidNewOngoingBilling(billing) {
  return fromNewOngoingBillingMode(toNewOngoingBillingMode(billing));
}
export function isValidNewOngoingBilling(billing) {
  return isEqual(getValidNewOngoingBilling(billing), billing);
}
var NewOngoingBillingMode = /*#__PURE__*/function (NewOngoingBillingMode) {
  NewOngoingBillingMode["UpfrontAndSkipBillingOnAcceptance"] = "UpfrontAndSkipBillingOnAcceptance";
  NewOngoingBillingMode["UpfrontAndBillOnAcceptance"] = "UpfrontAndBillOnAcceptance";
  NewOngoingBillingMode["UpfrontAndBillOnAcceptanceAndProrate"] = "UpfrontAndBillOnAcceptanceAndProrate";
  NewOngoingBillingMode["UpfrontAndStartPaused"] = "UpfrontAndStartPaused";
  NewOngoingBillingMode["NotUpfront"] = "NotUpfront";
  NewOngoingBillingMode["NotUpfrontAndStartPaused"] = "NotUpfrontAndStartPaused";
  NewOngoingBillingMode["NotUpfrontAndProrate"] = "NotUpfrontAndProrate";
  NewOngoingBillingMode["UpfrontAndProrateAndStartBillingAt"] = "UpfrontAndProrateAndStartBillingAt";
  NewOngoingBillingMode["NotUpfrontAndProrateAndStartBillingAt"] = "NotUpfrontAndProrateAndStartBillingAt";
  NewOngoingBillingMode["UpfrontAndStartBillingAt"] = "UpfrontAndStartBillingAt";
  NewOngoingBillingMode["NotUpfrontAndStartBillingAt"] = "NotUpfrontAndStartBillingAt";
  return NewOngoingBillingMode;
}(NewOngoingBillingMode || {});
function toNewOngoingBillingMode(billing) {
  if (billing.startBillingAt) {
    if (billing.isBilledUpfront) {
      return billing.isProrated ? NewOngoingBillingMode.UpfrontAndProrateAndStartBillingAt : NewOngoingBillingMode.UpfrontAndStartBillingAt;
    } else {
      return billing.isProrated ? NewOngoingBillingMode.NotUpfrontAndProrateAndStartBillingAt : NewOngoingBillingMode.NotUpfrontAndStartBillingAt;
    }
  } else if (billing.isBilledUpfront) {
    return billing.isPaused ? NewOngoingBillingMode.UpfrontAndStartPaused : billing.billUpfrontState.skipBillingOnAcceptance ? NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance : billing.isProrated ? NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate : NewOngoingBillingMode.UpfrontAndBillOnAcceptance;
  } else {
    return billing.isPaused ? NewOngoingBillingMode.NotUpfrontAndStartPaused : billing.isProrated ? NewOngoingBillingMode.NotUpfrontAndProrate : NewOngoingBillingMode.NotUpfront;
  }
}
function fromNewOngoingBillingMode(mode) {
  switch (mode) {
    case NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance:
      return {
        isBilledUpfront: true,
        isPaused: false,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(true),
        startBillingAt: false
      };
    case NewOngoingBillingMode.UpfrontAndBillOnAcceptance:
      return {
        isBilledUpfront: true,
        isPaused: false,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(false),
        startBillingAt: false
      };
    case NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate:
      return {
        isBilledUpfront: true,
        isPaused: false,
        isProrated: true,
        billUpfrontState: makeBillUpfrontState(false),
        startBillingAt: false
      };
    case NewOngoingBillingMode.UpfrontAndStartPaused:
      return {
        isBilledUpfront: true,
        isPaused: true,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(true),
        startBillingAt: false
      };
    case NewOngoingBillingMode.NotUpfront:
      return {
        isBilledUpfront: false,
        isPaused: false,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(true),
        startBillingAt: false
      };
    case NewOngoingBillingMode.NotUpfrontAndStartPaused:
      return {
        isBilledUpfront: false,
        isPaused: true,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(true),
        startBillingAt: false
      };
    case NewOngoingBillingMode.NotUpfrontAndProrate:
      return {
        isBilledUpfront: false,
        isPaused: false,
        isProrated: true,
        billUpfrontState: makeBillUpfrontState(false),
        startBillingAt: false
      };
    case NewOngoingBillingMode.UpfrontAndProrateAndStartBillingAt:
      return {
        isBilledUpfront: true,
        isPaused: false,
        isProrated: true,
        billUpfrontState: makeBillUpfrontState(false),
        startBillingAt: true
      };
    case NewOngoingBillingMode.NotUpfrontAndProrateAndStartBillingAt:
      return {
        isBilledUpfront: false,
        isPaused: false,
        isProrated: true,
        billUpfrontState: makeBillUpfrontState(false),
        startBillingAt: true
      };
    case NewOngoingBillingMode.UpfrontAndStartBillingAt:
      return {
        isBilledUpfront: true,
        isPaused: false,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(false),
        startBillingAt: true
      };
    case NewOngoingBillingMode.NotUpfrontAndStartBillingAt:
      return {
        isBilledUpfront: false,
        isPaused: false,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(false),
        startBillingAt: true
      };
  }
}
const fromUpfrontAndProrateAndStartBillingAt = toggledField => {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfrontAndProrateAndStartBillingAt;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.UpfrontAndStartBillingAt;
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndStartPaused;
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
  }
};
const fromNotUpfrontAndProrateAndStartBillingAt = toggledField => {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.UpfrontAndProrateAndStartBillingAt;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.NotUpfrontAndStartBillingAt;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.NotUpfrontAndStartPaused;
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.NotUpfrontAndProrate;
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.NotUpfrontAndProrateAndStartBillingAt;
  }
};
const fromUpfrontAndStartBillingAt = toggledField => {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfrontAndStartBillingAt;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndStartPaused;
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptance;
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.UpfrontAndProrateAndStartBillingAt;
  }
};
const fromNotUpfrontAndStartBillingAt = toggledField => {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.UpfrontAndStartBillingAt;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.NotUpfrontAndProrateAndStartBillingAt;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.NotUpfrontAndStartPaused;
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.NotUpfrontAndStartBillingAt;
  }
};
function changeNewOngoingBillingMode(mode, toggledField) {
  switch (mode) {
    case NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance:
      return fromUpfrontAndSkipBillingOnAcceptance(toggledField);
    case NewOngoingBillingMode.UpfrontAndBillOnAcceptance:
      return fromUpfrontAndBillOnAcceptance(toggledField);
    case NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate:
      return fromUpfrontAndBillOnAcceptanceAndProrate(toggledField);
    case NewOngoingBillingMode.UpfrontAndStartPaused:
      return fromUpfrontAndStartPaused(toggledField);
    case NewOngoingBillingMode.NotUpfront:
      return fromNotUpfront(toggledField);
    case NewOngoingBillingMode.NotUpfrontAndStartPaused:
      return fromNotUpfrontAndStartPaused(toggledField);
    case NewOngoingBillingMode.NotUpfrontAndProrate:
      return fromNotUpfrontAndProrate(toggledField);
    case NewOngoingBillingMode.UpfrontAndProrateAndStartBillingAt:
      return fromUpfrontAndProrateAndStartBillingAt(toggledField);
    case NewOngoingBillingMode.NotUpfrontAndProrateAndStartBillingAt:
      return fromNotUpfrontAndProrateAndStartBillingAt(toggledField);
    case NewOngoingBillingMode.UpfrontAndStartBillingAt:
      return fromUpfrontAndStartBillingAt(toggledField);
    case NewOngoingBillingMode.NotUpfrontAndStartBillingAt:
      return fromNotUpfrontAndStartBillingAt(toggledField);
  }
}
function fromUpfrontAndSkipBillingOnAcceptance(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndStartPaused;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    // Not allowed.
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptance;
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.UpfrontAndStartBillingAt;
  }
}
function fromUpfrontAndBillOnAcceptance(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndStartPaused;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate;
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.UpfrontAndStartBillingAt;
  }
}
function fromUpfrontAndBillOnAcceptanceAndProrate(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfrontAndProrate;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndStartPaused;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptance;
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.UpfrontAndProrateAndStartBillingAt;
  }
}
function fromUpfrontAndStartPaused(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfrontAndStartPaused;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptance;
    // Not allowed.
    case ToggledField.IsProrated:
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.UpfrontAndStartBillingAt;
  }
}
function fromNotUpfront(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.NotUpfrontAndStartPaused;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.NotUpfrontAndProrate;
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.NotUpfront;
    // Not allowed.
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.NotUpfrontAndStartBillingAt;
  }
}
function fromNotUpfrontAndStartPaused(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.UpfrontAndStartPaused;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.IsProrated:
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.NotUpfrontAndStartPaused;
    // Not allowed.
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.NotUpfrontAndStartBillingAt;
  }
}
function fromNotUpfrontAndProrate(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.NotUpfrontAndStartPaused;
    case ToggledField.BillOnAcceptance:
      return NewOngoingBillingMode.NotUpfrontAndProrate;
    // Not allowed.
    case ToggledField.StartBillingAt:
      return NewOngoingBillingMode.NotUpfrontAndProrateAndStartBillingAt;
  }
}